import { useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import Layout from "../components/Layout";
import { api } from "../lib/api";
import { Plus, FileText } from "@phosphor-icons/react";

export default function Quotes() {
  const [list, setList] = useState([]);

  const load = useCallback(async () => {
    const { data } = await api.get("/quotes");
    setList(data);
  }, []);
  useEffect(() => { load(); }, [load]);

  return (
    <Layout>
      <div className="flex justify-between items-center mb-6">
        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-[#A3A3A3] font-bold">Archivio</div>
          <h1 className="font-heading text-4xl font-black uppercase tracking-tighter leading-none mt-1">Preventivi</h1>
        </div>
        <Link to="/preventivo/nuovo" data-testid="new-quote-link"
          className="bg-[#FFD600] text-[#0A0A0A] h-12 px-4 rounded-md font-black uppercase flex items-center gap-2">
          <Plus size={20} weight="bold"/> Nuovo
        </Link>
      </div>
      {list.length === 0 ? (
        <div className="bg-[#1A1A1A] border border-[#333] rounded-md p-8 text-center text-[#A3A3A3]">
          Nessun preventivo. Crea il primo.
        </div>
      ) : (
        <div className="space-y-2">
          {list.map((q) => (
            <Link key={q.id} to={`/preventivi/${q.id}`} data-testid={`quote-${q.number}`}
              className="block bg-[#1A1A1A] border border-[#333] rounded-md p-4 hover:border-[#FFD600] transition">
              <div className="flex justify-between items-start gap-3">
                <div className="flex-1">
                  <div className="font-mono text-xs text-[#FFD600]">N° {q.number}</div>
                  <div className="font-heading text-xl font-bold uppercase">{q.client_name || "Senza cliente"}</div>
                  <div className="text-sm text-[#A3A3A3]">{q.site_address || "—"}</div>
                  <div className="text-xs text-[#A3A3A3] mt-1">{new Date(q.created_at).toLocaleDateString("it-IT")}</div>
                </div>
                <div className="text-right">
                  <div className="font-heading text-2xl font-black text-[#FFD600]">€ {(q.total || 0).toFixed(2)}</div>
                  <FileText size={20} weight="bold" className="text-[#A3A3A3] ml-auto mt-1" />
                </div>
              </div>
            </Link>
          ))}
        </div>
      )}
    </Layout>
  );
}
